<template>
  <Command @click="mediaPlayer?.stop()">
    <slot
      v-bind="{
        disabled: !mediaPlayer,
        icon: 'stop',
        label: t('tts.controls.stop'),
        toolTip: t('tts.controls.stop'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { inject, Ref } from "vue";
import { useI18n } from "vue-i18n";

import Command from "../command";
import MediaPlayer from "@/services/media/player";

const { t } = useI18n();

const mediaPlayer = inject("mediaPlayer") as Ref<MediaPlayer | null>;
</script>
